import { Card } from '../../components/Card/Card';
import styles from './PensionPage.module.css';

export function PensionPage() {
  return (
    <Card className={styles.card}>
      <div className={styles.badge}>KOMMER SNART</div>
      <h2 className={styles.title}>Pensionsopsparing</h2>
      <p className={styles.body}>
        Indtast dine pensionsordninger, så de tæller med i det samlede billede af jeres økonomi.
        Foreløbigt gemt som udkast:
      </p>
      <div className={styles.draft}>
        <div>
          <div className={styles.draftName}>PFA · Arbejdsmarkedspension</div>
          <div className={styles.draftMeta}>Senest opdateret manuelt</div>
        </div>
        <div className={styles.draftValue}>≈ 418.000 kr.</div>
      </div>
    </Card>
  );
}
